import { TabLink, Box, PageLink } from '@streem/ui-react';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { RolesAuth } from '../components/authorization/roles_auth';

export const useCallLogsPageTabLinks = () => {
    const history = useHistory();
    const pathName = useLocation().pathname;

    const tabLinks: TabLink[] = useMemo(
        () => [
            {
                link: () => (
                    <RolesAuth except="AGENT" key="streems-link">
                        <Box marginLeft={5}>
                            <PageLink
                                onClick={() => history.push(`./teamcalls`)}
                                active={pathName.includes('teamcalls') ?? false}
                                title="Team Calls"
                            />
                        </Box>
                    </RolesAuth>
                ),
            },
            {
                link: () => (
                    <RolesAuth except="SUPER_ADMIN" key="mystreems-link">
                        <Box marginLeft={5}>
                            <PageLink
                                onClick={() => history.push(`./mycalls`)}
                                active={pathName.includes('mycalls') || false}
                                title="My Calls"
                            />
                        </Box>
                    </RolesAuth>
                ),
            },
        ],
        [history, pathName],
    );

    return {
        tabLinks,
    };
};
